import { EmbedPartner } from "../enums/embed-partner";

export function embedPartnerAdapter(partnerString: string): EmbedPartner {
  if (partnerString === 'provet') {
    return EmbedPartner.PROVET;
  }

  throw new Error('Not a valid embed partner');
}